import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule, DatePipe, UpperCasePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatLine } from '@angular/material/grid-list';
import { MatDivider, MatListModule, MatListOption, MatSelectionList } from '@angular/material/list';
import { GamePageViewModel, GameViewFlatModel } from '../../../shared/models/GameModels';
import { GameService } from '../../../shared/services/game.service';
import { TranslatePipe } from '@ngx-translate/core';


export interface DialogData {
  dateFrom: Date;
  dateTo: Date;
}


@Component({
  selector: 'app-select-games-dialog',
  imports: [MatDialogModule, CdkScrollable, MatSelectionList, CommonModule, MatDivider, MatListOption, MatButtonModule, MatListOption, MatListModule, TranslatePipe, UpperCasePipe],
  templateUrl: './select-games-dialog.component.html',
  styleUrl: './select-games-dialog.component.css'
})
export class SelectGamesDialogComponent {
  game: GamePageViewModel;
  selectedDate: Date;
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);

  private gameService = inject(GameService);

  ngOnInit(): void {
    
    
    this.gameService.getGamesByDate(this.data.dateFrom, this.data.dateTo).subscribe(data=>{
      this.game = data;
      // console.log(data);
    });

  }

}
